exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".metrics-table-normal th.divider-right {\n  border-right: 2px solid #ddd;\n}\n\n.metrics-table-normal td.divider-right {\n  border-right: 2px solid #ddd;\n}\n\na {\n  cursor: pointer;\n}\n\n.good-metric {\n  color: #008023;\n}\n\n.bad-metric {\n  color: #D00;\n}\n\n.warn-metric {\n  color: #FA0;\n}\n\n.pointer {\n  cursor: pointer;\n}\n\n.sortable {\n  text-decoration: underline;\n}\n\n.side-nav {\n  position: fixed;\n  height: 100%;\n  left: 0px;\n  top: 100px;\n  width: 15%;\n  display: none;\n}\n\n@media (min-width: 992px) {\n  .side-nav {\n    display: block;\n  }\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/styles/buildViewer.scss
// module id = ./node_modules/css-loader/index.js!./node_modules/sass-loader/lib/loader.js!./src/styles/buildViewer.scss
// module chunks = 0